// Docs: IMPLEMENTATION.md § "Headword template"; FEATURES.md § "Word headers".
import React from 'react';
import { getCaseColor } from './WordHeaderCase';

const CASE_LABEL = {
  nominativ: 'Nominativ',
  akkusativ: 'Akkusativ',
  dativ: 'Dativ',
  genitiv: 'Genitiv',
  'akkusativ/dativ': 'Akkusativ/Dativ',
};

// One object slot of a headword template: "jmdm.", "etw.", "jmdn./etw.",
// bold and in the colour of its case. Without a known case it is plain text.
const WordHeaderSlot = ({ abbreviation, caseValue, className = '' }) => {
  if (!abbreviation) return null;
  const known = Boolean(CASE_LABEL[caseValue]);
  return (
    <span
      className={`${className} ${known ? 'font-semibold' : ''}`}
      style={known ? { color: getCaseColor(caseValue) } : undefined}
      title={known ? CASE_LABEL[caseValue] : undefined}
      data-testid="word-header-slot"
    >
      {abbreviation}
    </span>
  );
};

export default WordHeaderSlot;
